import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationFA from './locales/fa/translation.json';
import translationAR from './locales/ar/translation.json';
import translationES from './locales/es/translation.json';
import translationZHCN from './locales/zh-CN/translation.json';
import translationZHTW from './locales/zh-TW/translation.json';
import translationPA from './locales/pa/translation.json';
import translationHI from './locales/hi/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  fa: {
    translation: translationFA,
  },
  ar: {
    translation: translationAR,
  },
  es: {
    translation: translationES,
  },
  'zh-CN': {
    translation: translationZHCN,
  },
  'zh-TW': {
    translation: translationZHTW,
  },
  pa: {
    translation: translationPA,
  },
  hi: {
    translation: translationHI,
  }
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Use 'en' if detected language is not available
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

// Handle RTL direction dynamically
const handleDirectionChange = (lng: string) => {
  const code = lng ? lng.split('-')[0] : 'en';
  const isRtl = ['fa', 'ar'].includes(code);
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.body.dir = isRtl ? 'rtl' : 'ltr';
};

// Set initial direction
if (i18n.language) {
  handleDirectionChange(i18n.language);
}

// Update direction whenever language changes
i18n.on('languageChanged', (lng) => {
  handleDirectionChange(lng);
});

export default i18n;